
import Vue from 'vue'
import ResourcesTree from '@/components/stats/ResourcesTree.vue'
import UserActivityTabs from '@/components/stats/UserActivityTabs.vue'
import { mapGetters } from 'vuex'
import { WorkstationDocument } from '@/api/types/workstation'
import { SelectedIds } from '../../store/types/root'
import { UsageDocument } from '@/store/types/event'

type UserActiviyData = {
  selected: SelectedIds
  range: any
}

export default Vue.extend({
  name: 'UserActivity',
  components: {
    ResourcesTree,
    UserActivityTabs,
  },
  props: {
    adminView: {
      type: Boolean,
      required: true,
    },
    user: {
      // TODO add proper typing as PropType<...>
      type: Object,
      required: true,
    },
  },
  data(): UserActiviyData {
    return {
      selected: {},
      range: null,
    }
  },
  computed: {
    ...mapGetters({
      usage: 'event/usage',
      loadingUsage: 'event/isEventRequestPending',
      bundles: 'config/bundles',
      hasHoursRemaining: 'workstation/hasHoursRemaining',
    }),
    filteredUsage(): Array<UsageDocument> {
      if (!this.usage) return []
      const rangeStart = this.range && this.range.start ? new Date(this.range.start).getTime() : 0
      const rangeEnd =
        this.range && this.range.end ? new Date(this.range.end).getTime() : 10000000000000
      const lastStart: any = {}
      const reversed = [...(this.usage as Array<UsageDocument>)]
      reversed.reverse()
      const result = reversed
        .map((u) => {
          const ts = u.timestamp
          const resourceId = u.resourceId
          let durationHours = undefined
          if (u.categoryName === 'USER_STOP') {
            if (lastStart[resourceId]) {
              durationHours = (ts - lastStart[resourceId]) / 1000.0 / 60 / 60
            }
          }
          if (u.categoryName === 'USER_START') {
            lastStart[resourceId] = ts
          }

          return new UsageDocument({
            ...u,
            durationHours,
          })
        })
        .filter((u) => {
          if (u.timestamp < rangeStart) return false
          if (u.timestamp > rangeEnd) return false
          return this.selected[u.resourceId] !== false // undefined is ok too, it's the default
        })
      const reversedResult = [...result]
      reversedResult.reverse()
      return reversedResult
    },
    workstations(): Array<WorkstationDocument> {
      return this.user ? this.user.workstations : []
    },
  },
  methods: {
    workstation(uuid: string) {
      return this.workstations.filter((w) => w.uuid === uuid)[0]
    },
  },
  created() {
    if (this.user) {
      this.$store.dispatch('workstation/bindUserWorkstations')
      this.$store.dispatch('drive/bindUserDrives')
      this.$store.dispatch('event/getUsage', { userId: this.user.uid })
    }
  },
  watch: {
    user() {
      if (this.user) {
        this.$store.dispatch('event/getUsage', { userId: this.user.uid })
      }
    },
  },
})
